import { render, staticRenderFns } from "./tupu.vue?vue&type=template&id=ee8807e0&scoped=true&"
import script from "./tupu.vue?vue&type=script&lang=ts&"
export * from "./tupu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8807e0",
  null
  
)

export default component.exports